<template>
  <div class="dialog-bd">
    <div class="table">
      <el-table
        v-loading="loading"
        :data="tableData"
        ref="tableRef"
        class="common-el-table-styles"
        border
        height="300"
        style="width: 100%"
        @select="onTableRowSelect"
        @select-all="onTableSelectAll"
      >
        <el-table-column type="selection" width="35"> </el-table-column>
        <slot></slot>
      </el-table>
    </div>
    <div class="results">
      <div class="clear-hd">
        <span>已添加({{ result.length }})</span>
        <el-button type="text" @click="emit('clear-all')">清空全部</el-button>
      </div>
      <div class="clear-bd">
        <div v-for="(item, index) in result" :key="item.id">
          <el-tag closable class="tag-item" type="info" @close="emit('close-item', item, index)">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
              <span>{{ item.name }}</span>
            </el-tooltip>
          </el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, defineExpose } from 'vue'

defineProps({
  loading: Boolean,
  tableData: {
    type: Array,
    default: () => []
  },
  result: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['table-row-select', 'table-select-all', 'clear-all', 'close-item'])
const tableRef = ref(null)

const onTableRowSelect = (selection, row) => {
  emit('table-row-select', selection, row)
}

const onTableSelectAll = (selection) => {
  emit('table-select-all', selection)
}

const toggleRowSelection = (row, selected) => {
  if (tableRef.value) {
    tableRef.value.toggleRowSelection(row, selected)
  }
}

defineExpose({
  toggleRowSelection
})
</script>

<style lang="scss" scoped>
.dialog-bd {
  margin-top: 10px;
  display: flex;
}
.table {
  min-width: 60%;
  flex: 1;
}
.results {
  min-width: 290px;
  width: 290px;
  height: 300px;
  margin-left: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  vertical-align: top;
  .clear-hd {
    display: flex;
    height: 35px;
    padding: 0 10px;
    background: rgba(0, 0, 0, 0.02);
    border-bottom: 1px solid #dcdfe6;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
  }
  .clear-bd {
    height: 258px;
    padding: 10px;
    overflow: auto;
  }
  .tag-item {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
